import React from 'react';
import {Tab} from 'react-admin';
import SchemaIcon from '@mui/icons-material/SchemaTwoTone';
import CytoscapeComponent from 'react-cytoscapejs';
import fcose from 'cytoscape-fcose';
import cytoscape from 'cytoscape';
import './d4_tab_cyto.css';
import {d4UrlRest} from "../../Env";

cytoscape.use(fcose);


const layout = {
    name: 'fcose',
    quality: "proof",
    randomize: true,
    animate: true,
    animationDuration: 200,
    animationEasing: undefined,
    fit: true,
    padding: 30,
    nodeDimensionsIncludeLabels: false,
    uniformNodeDimensions: false,
    packComponents: true,
    step: "all",
    samplingType: true,
    sampleSize: 25,
    nodeSeparation: 75,
    piTol: 0.0000001,
    nodeRepulsion: node => 4500,
    idealEdgeLength: edge => 60,
    edgeElasticity: edge => 0.45,
    nestingFactor: 0.1,
    numIter: 5500,
    tile: true,
    tilingCompareBy: undefined,
    tilingPaddingVertical: 10,
    tilingPaddingHorizontal: 10,
    gravity: 0.25,
    gravityRangeCompound: 1.5,
    gravityCompound: 1.0,
    gravityRange: 3.8,
    initialEnergyOnIncremental: 0.3,
    fixedNodeConstraint: undefined,
    alignmentConstraint: undefined,
    relativePlacementConstraint: undefined
}


class CytoGraph extends React.Component {
    state = {
        w: window.innerWidth,
        h: (window.innerHeight * 0.7) | 0,
        elements: []
    }


    componentDidMount() {
        this.setState({
            w: window.innerWidth,
            h: (window.innerHeight * 0.7) | 0
        })
        var query = {id: this.props.record.id}
        fetch(d4UrlRest + '/graph_data', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ids: [this.props.record.id]}),
            }
        )
            .then(res => res.json())
            .then((data) => {
                this.setState({elements: data})
            })
            .catch(console.log)
        this.setUpListeners()
        this.cy.minZoom(0.1)
        this.cy.maxZoom(5.0)
    }


    setUpListeners = () => {
        const obj_id = this.props.record.id;
        this.cy.on('click', 'node', function (evt) {
            var href_array = window.location.href.split('/')
            href_array[href_array.length - 3] = encodeURIComponent(evt.target[0].data().url);
            if (evt.target[0].data().url.includes("/products/")) {
                href_array[href_array.length - 4] = "products";
            }
            if (evt.target[0].data().url.includes("/functions/")) {
                href_array[href_array.length - 4] = "functions";
            }
            if (evt.target[0].data().url.includes("/locations/")) {
                href_array[href_array.length - 4] = "locations";
            }
            if (evt.target[0].data().url.includes("/organisations/")) {
                href_array[href_array.length - 4] = "organisations";
            }
            const new_href = href_array.join('/')
            window.open(new_href, "_self");
        });
        this.cy.on('add', function (evt) {
            evt.cy.elements('node[class = "product"]')
                .forEach(node => node.style('background-image', '/Icons/product555.png'));
            evt.cy.elements('node[class = "function"]')
                .forEach(node => node.style('background-image', '/Icons/function555.png'));
            evt.cy.elements('node[class = "location"]')
                .forEach(node => node.style('background-image', '/Icons/location555.png'));
            evt.cy.elements('node[class = "organisation"]')
                .forEach(node => node.style('background-image', '/Icons/organisation555.png'));
            evt.cy.elements('node[id = "' + obj_id + '"]')
                .forEach(node => node.style('background-color', '#c3b58b'));
            evt.cy.elements('edge[state = "passive"]')
                .forEach(node => node.style({
                    'line-color': '#aaaa48',
                    'source-arrow-color': '#aaaa48',
                    'target-arrow-color': '#aaaa48'
                }));
        });
    }

    render() {
        return <CytoscapeComponent
            elements={this.state.elements}
            // location={location}
            style={{width: this.state.w, height: this.state.h}}
            cy={(cy) => {
                this.cy = cy;
                cy.layout(layout).run();
                cy.fit();
            }}
            stylesheet={[
                {
                    selector: 'node',
                    style: {
                        "shape": "round-rectangle",
                        "corner-radius": "2px",
                        "content": "data(label)",
                        "font-size": "6px",
                        "text-valign": "bottom",
                        "text-halign": "center",
                        "text-margin-y": "2px",
                        "opacity": "0.9",
                        "background-color": "#CCC",
                        "background-fit": "contain",
                        "color": "#222",
                        "overlay-padding": "30px",
                        "z-index": "-10",
                    }
                },
                {
                    selector: 'edge',
                    "style": {
                        "curve-style": "bezier",
                        // "source-arrow-shape": "data(source_arrow_shape)",
                        // "target-arrow-shape": "data(target_arrow_shape)",
                        "target-arrow-shape": "triangle",
                        "opacity": "0.6",
                        "width": "2px",
                        "color": "#666",
                        "line-color": "#777",
                        "source-arrow-color": "#777",
                        "target-arrow-color": "#777",
                        "label": "data(label)",
                        "text-opacity": "1.0",
                        "text-rotation": "autorotate",
                        "font-size": "5px",
                        "text-valign": "center",
                        "text-halign": "center"
                    }
                }
            ]}
            layout={layout}
        />;
    }
}


function D4TabCyto(props, controllerProps) {
    return (
        <Tab label="Explore1 (𝝰)" path="explore1" icon={<SchemaIcon/>}>
            <CytoGraph {...props} {...controllerProps} />
        </Tab>
    );
};

export default D4TabCyto;
